<script setup lang="ts">
  import type { InfoBlockStoryblok, WysiwygStoryblok } from '@/storyblok/component-types-sb'
  import { MODAL_DATA_ATTRIBUTE } from '@/utils/inlineModalHelpers'

  const props = defineProps<{
    blok: InfoBlockStoryblok
  }>()

  const { t } = useI18n()

  const getContent = () => {
    if (!props.blok.content) {
      return null
    }

    if (!props.blok.hasModal) {
      return props.blok.content[0]
    }

    const contentWithModal = { ...props.blok.content[0] }

    const readMore = props.blok.readMore || t('readMore')

    contentWithModal.content += ` <a ${MODAL_DATA_ATTRIBUTE}>${readMore}</a>`

    contentWithModal.modalData = {
      modalTitle: props.blok.modalTitle,
      modalContent: props.blok.modalContent
    }

    return contentWithModal
  }

  const infoContent = ref<WysiwygStoryblok | null>(getContent())
</script>

<template>
  <UiInfo
    :title="blok.title"
    :variant="blok.variant"
    :has-icon="blok.hasIcon"
  >
    <template #content>
      <StoryblokComponent
        v-if="infoContent"
        :key="infoContent._uid"
        class="!mt-0"
        :blok="infoContent"
      />
    </template>
  </UiInfo>
</template>
